import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'
import { BanksResponse } from './types'

const fetchBanks = async () => {
  const response = await httpClientPrivate.get<BanksResponse>(
    `${config.restUrl}/v1/backoffice/e-claim/banks`,
  )

  return response.data
}

const useGetBanks = () => {
  const queryKey = ['useGetBanks']
  const queryFn = async () => fetchBanks()
  const queryResult = useQuery({ queryKey, queryFn })

  return { ...queryResult }
}

export { fetchBanks, useGetBanks }
